import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HomeIcon from '@material-ui/icons/Home';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

/** Home page at `/`: the developer's envs, pipelines, pull requests and shortcuts. */
const homePage = PageBlueprint.make({
  params: {
    path: '/',
    title: 'Home',
    loader: () => import('./components/HomePage').then(m => <m.HomePage />),
  },
});

/**
 * "Mon travail" at `/my-work`: sprint tickets with their PRs, env and pipelines, failures and
 * reviews. The sidebar renders it with MyWorkSidebarItem (count of things to handle).
 */
const myWorkPage = PageBlueprint.make({
  name: 'my-work',
  params: {
    path: '/my-work',
    title: 'Mon travail',
    icon: <WorkOutlineIcon fontSize="inherit" />,
    loader: () =>
      import('./components/MyWork/MyWorkPage').then(m => <m.MyWorkPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'dev-home',
  // Header icon of pages without their own: same as the sidebar entry
  icon: <HomeIcon fontSize="inherit" />,
  extensions: [homePage, myWorkPage],
});
